import React from "react";
import { OptionSelect, SelectComponent } from "../../Atoms";
import { useSelectSessionValidation } from "hooks";
import {
  getDefaultValueForSelect,
  userType,
  validateUserTypePermited,
} from "helpers/functionsHelpers";

interface SelectSessionValidationProps {
  classname?: string;
  valueCompanie: string;
  onChangeCompanie: (option: OptionSelect) => void;
  valueBranch?: string;
  onChangeBranch: (option: OptionSelect) => void;
  isErrorCompanie?: boolean;
  errorMessageCompanie?: string;
  isErrorBranch?: boolean;
  errorMessageBranch?: string;
  hideBranch?: boolean; 
}

export const SelectSessionValidation: React.FC<
  SelectSessionValidationProps
> = ({
  classname,
  valueCompanie,
  valueBranch = "0",
  isErrorCompanie = false,
  errorMessageCompanie = "",
  isErrorBranch = false,
  errorMessageBranch = "",
  hideBranch = false,
  onChangeCompanie,
  onChangeBranch,
}) => {
  const {
    companiesOptions,
    branchesOptions,
    t,
    idCopmanie,
    idBranch,
    companyValue,
    branchValue,
    setIdCopmanie,
    setIdBranch,
    getColSpanBySession,
  } = useSelectSessionValidation(valueCompanie, valueBranch);

  return (
    <div className={`grid grid-cols-1 gap-4 xl:grid-cols-12 ${classname}`}>
      {validateUserTypePermited([userType.adminitrador]) && (
        <div className="col-span-6">
          <SelectComponent
            label={t("selectValidationSession.selectCompanieLabel")}
            placeholder={t("selectComponent.defaultValue")}
            id="company"
            value={companyValue}
            options={companiesOptions}
            defaultValue={companiesOptions.find(
              (option) => option.value === idCopmanie
            )}
            onChange={(e: OptionSelect) => {
              onChangeCompanie(e);
              setIdCopmanie(e.value ?? "");
            }}
          />
          {isErrorCompanie ? (
            <p className="mt-1 text-sm text-red-500">{errorMessageCompanie}</p>
          ) : null}
        </div>
      )}
      {!hideBranch && 
        (validateUserTypePermited([userType.empresa]) ||
          validateUserTypePermited([userType.adminitrador])) && (
          <div className={getColSpanBySession()}>
            <SelectComponent
              label={t("selectValidationSession.selectBranchLabel")}
              placeholder={t("selectComponent.defaultValue")}
              id="branch"
              defaultValue={getDefaultValueForSelect(branchesOptions, idBranch)}
              value={branchValue}
              options={branchesOptions}
              onChange={(option: OptionSelect) => {
                onChangeBranch(option);
                setIdBranch(option.value ?? "");
              }}
            />
            {isErrorBranch ? (
              <p className="mt-1 text-sm text-red-500">{errorMessageBranch}</p>
            ) : null}
          </div>
        )}
    </div>
  );
};
